// extracted by mini-css-extract-plugin
module.exports = {"FXPairs":"FXPairsList_FXPairs__3NSpC","message":"FXPairsList_message__2-Z_O"};